if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			loadProductFirst: true,
			numberFilterTree: 2,
			selectOptionContainer: '.grid__item .card-wrapper',
			stickyFixTopPos: true,
          	filterTreeMobileStyle: 'style3'
		},
		selector: {
			otpTopCartCount: '.cart-count-bubble'
		}
	};
}
// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		// itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

      	// Add Color Swatches
 		 itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildSwatch(data));

        // Boost 168073 - Add filtered variant to the product URL
    
        var selectedVariant = null;

        // Extract the values from the queryParams
        const color = Globals.queryParams['pf_opt_color'] ? Globals.queryParams['pf_opt_color'][0] : null;
        const size = Globals.queryParams['pf_opt_size'] ? Globals.queryParams['pf_opt_size'][0] : null;
        const locations = Globals.queryParams['pf_vl_locations'] ? Globals.queryParams['pf_vl_locations'] : null;
        
        // Filter the items based on the URL parameter values
        const filteredVariant = data.variants.filter((item) => {
          if (color && item.option_color !== color) {
            return false;
          }
          if (size && item.option_size !== size) {
            return false;
          }
          if (item.inventory_quantities && locations?.length > 0 && !locations.every((loc) => item.inventory_quantities[loc] > 0 )) {
            return false;
          }
          return true;
        });
      
        // if (filteredVariant.length !== data.variants.length) {
        //   selectedVariant = filteredVariant[0];
        // }
        /* Boost 306699 */
        selectedVariant = filteredVariant[0];
        /* Boost 306699 */
        
        if ((color || size || locations?.length) && !selectedVariant) {
          return itemHtml = '';
        }
        
		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		//itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data) + (selectedVariant ? '?variant=' + selectedVariant.id : ''));
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}
		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			// paddingBottom = 1 / aspectRatio * 100;
			paddingBottom = 100;


			html += '<div';
			if (boostPFSThemeConfig.custom.hasOwnProperty('add_image_padding') &&
				boostPFSThemeConfig.custom.add_image_padding === true) {
				html += ' class="card__media-full-spacer"';
			}
			html += '>';
			html += '<div class="media media--transparent media--';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size')) {
				html += boostPFSThemeConfig.custom.media_size;
			}
			html += ' media--hover-effect"';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size') &&
				boostPFSThemeConfig.custom.media_size == 'adapt' &&
				images.length > 0) {
				html += ' style="padding-bottom: ' + paddingBottom + '%"';
			}
			html += '>';

            var defaultImage = getPositionImage(data.images_info);
          //   console.log('prod: ', data.title);
          //   console.log('.images: ', images);
          // console.log(defaultImage);

            var selectedVariant = null;
            // Extract the values from the queryParams
            const color = Globals.queryParams['pf_opt_color'] ? Globals.queryParams['pf_opt_color'][0] : null;
            const size = Globals.queryParams['pf_opt_size'] ? Globals.queryParams['pf_opt_size'][0] : null;
            const locations = Globals.queryParams['pf_vl_locations'] ? Globals.queryParams['pf_vl_locations'] : null;
            
            // Filter the items based on the URL parameter values
            const filteredVariant = data.variants.filter((item) => {
              if (color && item.option_color !== color) {
                return false;
              }
              if (size && item.option_size !== size) {
                return false;
              }
              if (item.inventory_quantities && locations?.length > 0 && !locations.every((loc) => item.inventory_quantities[loc] > 0 )) {
                return false;
              }
              return true;
            });
          
            // if (filteredVariant.length !== data.variants.length) {
            //   selectedVariant = filteredVariant[0];
            // }
            /* Boost 306699 */
            selectedVariant = filteredVariant[0];
            /* Boost 306699 */
            console.log(selectedVariant);
            if (selectedVariant) {
              defaultImage = selectedVariant.image;
            }
            
			html += '<img class="motion-reduce"' +
				//'loading="lazy"' +
				//'srcset="' + dataSrcSet + '" ' +
				//'height="' + images[0].height + '" ' +
				//'width="' + images[0].width + '" ' +
				//'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' +  Utils.optimizeImage(defaultImage, '533x') + '" ' +
				'alt="' + imgAlt + '" />';

			//if (activeSwapImage) {
				html += '<img class="motion-reduce-swap"' +
				//'loading="lazy"' +
				//'srcset="' + flipImageSrcSet + '" ' +
				//'height="' + images[1].height + '" ' +
				//'width="' + images[1].width + '" ' +
				//'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(defaultImage, '533x') + '" ' +
				'alt="' + imgAlt + '" />';
			//}
			html += '</div>';
			html += '</div>';
		} else {
			html += '<div class="card__content"><h2 class="card__text h2">' + data.title  + '</h2></div>'
		}
		return html;
	}

    function getPositionImage(images){
      if(Utils.getParam('pf_opt_color') !== null){
        return images[0].src;
      } else {
        if(typeof(images[1]) !== 'undefined'){
          return images[1].src;
        }else{
          return images[0].src;
        }
      }
    }

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else {
      html = 'card--outline';
    }
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(data.price_min))
			: Utils.formatMoney(data.price_min);
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<dl>
						<div class="price__regular">
							<dt>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular">
									${moneyPrice}
						  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<s class="price-item price-item--regular">
								${Utils.formatMoney(data.compare_at_price_min)}
								</s>
						  	</dd>
							<dt>
							  <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							</dt>
							<dd class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
			var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'selected="selected"'
					}
					sortingItemsHtml += '<li value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		jQ('.boost-pfs-filter-top-sorting ul li').on('click',function(e) {
			FilterApi.setParam('sort', jQ(this).attr('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};

  // Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
      
      	// ProductList.prototype.buildExtrasProductListByAjax(data, 'boost-pfs-integration', function(results){
       //    results.forEach(function(result, index){
       //      // Append the custom html to product item
       //      jQ('[boost-pfs-item="'+ result.id+ '"] .boost-price').html(result.price_html);
       //    })
       //  });	

        if (boostPFSConfig.customer.isLogged) {
            var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
            var localeURLPart = "";
        
            if (hasShopifyRoutes) {
                localeURLPart = Shopify.routes.root.replace(/\/$/, '');
            }
                  
            for (var i = 0; i < data.length; i++) {
    		    const prodId = data[i]['id'];
    		    quickUrl = localeURLPart + '/products/' + data[i].handle + '?view=boost-pfs-integration';
    		    jQ.ajax({
    		        url: quickUrl,
    		        success: function(result) {
    		            try {
    		                var res = JSON.parse(result);
    		                jQ('[data-id="' + res.id + '"]').find('.boost-price').html(res.price_collection.trim());
    		            } catch (error) {
    		                console.log(error);
    		            }
    		        }
    		    });
    		}
        }
        
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
	
        jQ('.boost-pfs-filter-left-col-inner .sorting label').on('click',function(){
          if(jQ(this).attr('aria-expanded') == "true"){
            jQ(this).attr('aria-expanded',"false");
          }else{
          	jQ(this).attr('aria-expanded',"true");
          }
        });
      
        jQ('.product-grid-swatch-wrapper .swatch-color').on('mouseenter mouseleave',function(evt){
          var variantImage = jQ(this).data('image');
          var variantURL = jQ(this).data('url');
          var variantOldImage = jQ(this).data('old-image');
          jQ('.product-grid-swatch-wrapper .swatch-color').removeClass('active');
          jQ(this).addClass('active');
          jQ(this).closest('.grid__item').find('a').attr('href',variantURL);
          if(evt.type === 'mouseover'){
            jQ(this).closest('.grid__item').find('.motion-reduce-swap').attr('src',variantImage);
          }else{
          	//jQ(this).closest('.grid__item').find('.motion-reduce-swap').attr('src',variantOldImage);
          }
        });

      
        if(!boostPFSConfig.customer.isLogged){
          jQ('.boost-pfs-filter-option-price').hide();
          jQ('.boost-pfs-filter-option-location').hide();
        }
    };

	/************************** END BUILD TOOLBAR **************************/

  function buildSwatchColor(imageUrl, colorCodes, type) {
        var backgroundColor = '';
      	var backgroundImage = '';
      	var background = '';
		switch (type) {
				case FilterOptionItemSwatch.SwatchType.ONE_COLOR:
					if (colorCodes.length > 0 && colorCodes[0]) {
						backgroundColor = colorCodes[0];
                      	backgroundImage = '""';
					}
					break;
				case FilterOptionItemSwatch.SwatchType.TWO_COLORS:
					if (colorCodes.length > 1 && colorCodes.colorCodes[0] && colorCodes.colorCodes[1]) {
						backgroundImage = 'linear-gradient(to top left, ' + colorCodes.colorCodes[1] + ' 50%, ' + colorCodes[0] + ' 50%);';
						backgroundColor = 'transparent';
					}
					break;
				case FilterOptionItemSwatch.SwatchType.IMAGE:
					if (imageUrl) {
						backgroundImage = 'url(' + imageUrl + ');';
						backgroundColor = buildSwatchColor(null, colorCodes, type); // Fallback color for image
					}
					break;
			}
      	background = 'background-color: '+backgroundColor+'; background-image: '+backgroundImage+';';
      	return background;
	}
  
	// Build Color Swatches
function buildSwatch(data) {
    var html = '';
    var values = [];
    var swatchItems = [];
  	var swatchSettings = Settings.getSettingValue('swatch_settings');
  
    //if (boostPFSConfig.custom.collection_swatches) {
      data.variants.forEach(function (variant) {
        var colorValue = '';
        var optionValue = '';
        // Fix boost #203230
        if (variant.original_merged_options) {
          variant.original_merged_options.forEach(function (option) {
          // End #203230
            var key = option.split(':')[0];
            var value = option.split(':')[1];
            if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1) {
              values.push(value.toLowerCase());
              colorValue = value;
              optionValue = key;
            }
          });
        } else {
          variant.merged_options.forEach(function (option) {
          // End #203230
            var key = option.split(':')[0];
            var value = option.split(':')[1];
            if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1) {
              values.push(value.toLowerCase());
              colorValue = value;
              optionValue = key;
            }
          });
        }
        
        
        var lwSwatchName = colorValue.toLowerCase();
        var crColorSetting = swatchSettings['filter:color_'+lwSwatchName];
        if(crColorSetting){
        	var ctBackground = buildSwatchColor(crColorSetting.imageUrl,crColorSetting.colorCodes,crColorSetting.type);
        }else{
        	var ctBackground = '';
        }
        if(getVariantColor(variant.id,data) !== ''){
        	ctBackground = "background-color:"+ getVariantColor(variant.id,data) +";";
        }
        if (checkVariantBaseLocation(variant) && colorValue) {
          var fImage = data.images_info[0];
          var fImageSrc = '';
          if(fImage && typeof(fImage.src) !== 'undefined' && fImage.src !== ''){
            fImageSrc = fImage.src;
          }
          var swatchItem = '<span class="swatch-custom swatch-color" data-url="'+ Utils.buildProductItemUrlWithVariant(data) +'?variant='+ variant.id +'" data-color="'+ colorValue +'" data-image="{{variantImage}}" data-old-image="'+ fImageSrc +'" style="'+ ctBackground +'">' +
            //'<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
            '</span>';

          swatchItem = swatchItem.replace(/{{swatchShape}}/g, boostPFSConfig.custom.collection_swatches_shape);
          swatchItem = swatchItem.replace(/{{colorBackground}}/g, Utils.slugify(colorValue).split('-').pop());
          swatchItem = swatchItem.replace(/{{slugifyOptionValue}}/g, Utils.slugify(optionValue).replace('-', '_'));
          swatchItem = swatchItem.replace(/{{slugifyColorValue}}/g, Utils.slugify(colorValue).replace('-', '_'));
          swatchItem = swatchItem.replace(/{{variantUrl}}/g, Utils.buildProductItemUrl(data) + '?variant=' + variant.id);

          var colorImage = boostPFSAppConfig.general.file_url.split('?')[0] + Utils.slugify(colorValue) + '_50x.png';
          //swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);

          var variantImage = '';
          var noImageClass = '';
          if (variant.image) {
            switch (boostPFSConfig.custom.products_per_row) {
              case 2: variantImage = Utils.optimizeImage(variant.image, '600x'); break;
              case 3: variantImage = Utils.optimizeImage(variant.image, '500x'); break;
              default: variantImage = Utils.optimizeImage(variant.image, '400x'); break;
            }
          }
          swatchItem = swatchItem.replace(/{{colorImage}}/g, Utils.optimizeImage(variant.image, '25x25'));
          swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
          swatchItems.push(swatchItem);
        }
      })
    //}
    if (swatchItems.length > 1) {
      html = '<div class="product-grid-swatch-wrapper">' +
        swatchItems.join(' ') +
        '</div>';
    }
    return html;
  }
  
  FilterOption.prototype.getTemplate = function() {
		switch (this.filterTreeType) {
			case 'vertical':
				return `
				<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">
					<div class="{{class.filterOptionTitle}}">
						<button aria-controls="{{ada.filterOptionDomId}}" aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">
							<span class="{{class.filterOptionTitle}}-text">
								{{blockTitle}}
								<span class="{{class.filterOptionTitle}}-count">
									{{numberAppliedFilterItems}}
								</span>
							</span>
							{{tooltip}}
							<span class="boost-custom-expanse"><svg class="AccordionExpandIcon" viewBox="0 0 140 140" width="11" height="10" xmlns="http://www.w3.org/2000/svg"><g><path class="AccordionExpandIcon" d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z" fill="#4F4F4F"></path></g></svg></span>
						</button>
						<p class="boost-pfs-filter-selected-items-mobile"></p>
						{{clearButton}}
					</div>
					<div class="{{class.filterOptionContent}}">
						{{searchBox}}
						<div class="{{class.filterOptionContentInner}}">
							{{blockContent}}
						</div>
						{{viewMore}}
					</div>
				</div>
			`.trim();
			case 'horizontal':
				return `
				<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">
					<div class="{{class.filterOptionTitle}}">
						<button aria-controls="{{ada.filterOptionDomId}}" aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">
							<span class="{{class.filterOptionTitle}}-text">
							{{blockTitle}}
								<span class="{{class.filterOptionTitle}}-count">
									{{numberAppliedFilterItems}}
								</span>
							</span>
							{{tooltip}}
						</button>
					</div>
					<div class="{{class.filterOptionContent}}">
						<div class="{{class.filterOptionContentInner}}">
							{{blockContent}}
						</div>
						{{viewMore}}
						{{applyButton}}
						{{clearButton}}
					</div>
				</div>
			`.trim();
			default:
				console.warn('filterTreeType is wrong');
		}
	}
  
  function getVariantColor(variantId, data){
  	var metafields = data.metafields;
    for(var i = 0; i < metafields.length; i++){
      if(metafields[i].key == 'collection_swatch' && metafields[i].id == variantId){
      	return metafields[i].value;
      }
    }
    return '';
  }

  function checkVariantBaseLocation(variant){
    var selectedLocation = Globals.queryParams['pf_vl_locations'];
    if(typeof(selectedLocation) !== 'undefined' && selectedLocation !== null && selectedLocation.length >0 && variant.inventory_quantities){
      var locationInventory = 0;
      for(var i = 0; i < selectedLocation.length; i++){
        locationInventory = locationInventory + variant.inventory_quantities[selectedLocation[i]];
      }
      
      if(locationInventory > 0){
        return true;
      }else{
        return false;
      }
    }
    // if(typeof(selectedLocation) !== 'undefined' && selectedLocation !== null && selectedLocation.length >0){
    //   var locationInventory = 0;
    //   for(var i = 0; i < selectedLocation.length; i++){
    //     locationInventory = locationInventory + variant.inventory_quantities[selectedLocation[i]];
    //   }
      
    //   // console.log(variant.inventory_policy, locationInventory);
    //   if(variant.inventory_quantity > 0){
    //     return true;
    //   }else{
    //     return variant.inventory_policy == "continue";
    //   }
    // }
    return true;
  }

  // START BOOST 216850 
  FilterApi.beforeCall = function(eventType, eventInfo) {
    // START only show some products to lloged in customers
    if(!Globals.queryParams.h_options) Globals.queryParams.h_options = []
    if(!boostPFSConfig.customer.isLogged){
      Globals.queryParams.h_options.push('non-members');    
    }
  

  // START Remove quotes & dashes from searching
  if (Utils.isSearchPage()) {
      Globals.queryParams.q = (Globals.queryParams.q || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' ');
    }
  }
  // END BOOST 216850 
  
})();
